export const AUTH0_DOMAIN = "progentecs-dev.us.auth0.com"
export const AUTH0_CLIENT_ID = "jFgbWBNEPNxqZ8ajWh3M1IRpVpq2JTh0s"
export const AUTH0_REDIRECT_URI = "https://aioncare.lupuscorner.com/token/"; 